/** True when Tag Assistant / GA debug session (URL, cookie, or referrer). */
export function isTagDebugSession(): boolean {
  try {
    if (import.meta.env.DEV) return true;
    const params = new URLSearchParams(window.location.search);
    if (params.has('_dbg') || params.has('ga_debug') || params.has('gtm_debug')) return true;
    if (document.referrer.includes('tagassistant.google.com')) return true;
    return /(?:^|;\s*)__TAG_ASSISTANT=/.test(document.cookie);
  } catch {
    return false;
  }
}
